import User from './user.vue'
export default User



// WEBPACK FOOTER //
// ./src/components/main/components/user/index.js